import { render, staticRenderFns } from "./AlertsContainer.vue?vue&type=template&id=c1ee46b2&"
import script from "./AlertsContainer.vue?vue&type=script&lang=js&"
export * from "./AlertsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports